"use strict";

define('model/email.message',['./base'], function (Base) {
  var EmailMessage = Base.extend({});
  return EmailMessage;
});

